import { IDocumentImageSource } from "../../../domain/document";

export class ClaioSchemaExecuteResult {
  isComplete: boolean;
  imageSource: IDocumentImageSource;
  drawLayerImageSource: IDocumentImageSource;
  drawObjectData: string;
}
